<div *ngFor="let companyCategory of categoryTree" class="category-tree">
  <div class="category-title">{{ companyCategory.company_category_name }}</div>

  <ul>
    <ng-container *ngFor="let category of companyCategory.categories">
      <li>
        <sui-checkbox
          [checked]="isSelected(category.id)"
          (checkedChange)="toggleCheckbox(category)"
        >
          {{ category.name }}
        </sui-checkbox>

        <ul *ngIf="category.children?.length > 0">
          <ng-container
            *ngTemplateOutlet="
              childTemplate;
              context: { $implicit: category.children }
            "
          ></ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>

  <ng-template #childTemplate let-children>
    <li *ngFor="let child of children">
      <sui-checkbox
        [checked]="isSelected(child.id)"
        (checkedChange)="toggleCheckbox(child)"
      >
        {{ child.name }}
      </sui-checkbox>
      <ul *ngIf="child.children && child.children.length > 0">
        <ng-container
          *ngTemplateOutlet="
            childTemplate;
            context: { $implicit: child.children }
          "
        ></ng-container>
      </ul>
    </li>
  </ng-template>
</div>
